import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { getListAttachImageByAiChatPost } from '@/service/chatAIService';

import ViewImage from './ViewImage';
import ViewDocument from './ViewDocument';


/**
 * Component to render message content from current user (isFromMe)
 * Handles: Images → Files → Text message (in order)
 */
function MessageIsFromMe({ message, filterContent, isAiAutoLog }) {
    const [attachImages, setAttachImages] = useState([]);
    const [attachDocuments, setAttachDocuments] = useState([]);

    useEffect(() => {
        if (message?.isMockMsg) {
            // If message already has attachments data from mock, use it directly
            if (message?.attachments && !Utils.isEmptyArray(message?.attachments)) {
                setAttachImages(message.attachments);
            }
            if (message?.fileAttachments && !Utils.isEmptyArray(message?.fileAttachments)) {
                setAttachDocuments(message.fileAttachments);
            }
            // Skip API call if mock data
            return;
        }

        // const metaData = Utils.convertJSONDataToObject(message.metaData);
        // If no local data and postType indicates attachments, query from API
        if (([
                Constant.POST_TYPE.IMAGE,
                Constant.POST_TYPE.FILE,
                Constant.POST_TYPE.MSG_FILES,
            ].includes(message?.postType) || message?.isHasKboardScreenCapture)
            && !message?.isMockMsg
        ) {
            getListAttachImageByAiChatPost(message)
                .then(listAttachments => {
                    if (listAttachments && !Utils.isEmptyArray(listAttachments)) {
                        // Separate images and documents by file extension
                        const images = [];
                        const documents = [];
                        
                        listAttachments.forEach(attachment => {
                            const extension = Utils.getFileExtension(attachment?.s3Path || '');
                            if (Constant.ATTACH_FILE_IMAGE_LIST_EXTENSIONS.includes(extension?.toLowerCase())) {
                                images.push(attachment);
                            } else {
                                documents.push(attachment);
                            }
                        });

                        setAttachImages(images);
                        setAttachDocuments(documents);
                    }
                })
                .catch(error => {
                    console.log('getListAttachImageByAiChatPost error ', error);
                });
        }
    }, [message]);

    const displayFilterContent = filterContent
        ? filterContent.replace(
              /\[SELECTION_KBOARD_XML_START\][\s\S]*?\[SELECTION_KBOARD_XML_END\]\n?/g,
              '',
          )
        : '';

    return (
        <div className="ai-chat-msg-wrap">
            {/* 1. Render Images first */}
            {!Utils.isEmptyArray(attachImages) && (
                <div className="ai-render-attach-img-list">
                    {attachImages.map(attData => (
                        <ViewImage key={attData?.id || attData?.s3Path} imageData={attData} />
                    ))}
                </div>
            )}

            {/* 2. Render Documents second */}
            {!Utils.isEmptyArray(attachDocuments) && (
                <div className="ai-render-attach-document-list">
                    {attachDocuments.map(doc => (
                        <ViewDocument key={doc?.id || doc?.s3Path} documentData={doc} />
                    ))}
                </div>
            )}

            {/* 3. Render Text message last */}
            {!Utils.isEmptyString(message.content) && (
                <div
                    className="ai-message-text"
                    style={{ backgroundColor: isAiAutoLog ? '#FFEDB3' : '' }}
                    dangerouslySetInnerHTML={{ __html: displayFilterContent }}
                />
            )}
        </div>
    );
}

MessageIsFromMe.propTypes = {
    message: PropTypes.object.isRequired,
    filterContent: PropTypes.string,
    isAiAutoLog: PropTypes.bool
};

export default MessageIsFromMe;
